<app-header></app-header>
<ngx-spinner></ngx-spinner>
<div class="page-wrapper wrapper">
  <section class="page-top-header">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-12 col-md-7">
          <h2 class="mb-2">{{ "PAYMENT_INFO.SUBSCRIBE_NOW" | translate }}</h2>
          <p>{{ "PAYMENT_INFO.MESSAGE" | translate }}</p>
        </div>
      </div>
    </div>
  </section>
  <!-- STANDARD -->
  <section class="user-plan shadow_box">
    <div class="container">
      <div class="row m-0" *ngIf="step_1">
        <div class="plan-box">
          <div
            class="plans-content"
            *ngFor="let plan of subscription; let i = index"
            [ngClass]="{
              planActive:
                userinfo.subscription_type &&
                (plan.type | translate | lowercase).split(' ')[0] ==
                  (userinfo.subscription_type | lowercase)
            }"
          >
            <p class="mb-0">{{ plan.type | translate | uppercase }}</p>
            <i
              [ngClass]="
                plan.type !== 'Standard'
                  ? 'mdi mdi-calendar-month-outline'
                  : 'mdi mdi-calendar-outline'
              "
            ></i>
            <h1 class="mb-3">
              ${{ plan.price }} <span>{{ plan.duration | translate }} </span>
            </h1>
            <h5>{{ plan.heading | translate }}</h5>
            <ul>
              <li
                *ngFor="
                  let feature of plan.description.feature
                    | limitTo: planArrayLimit:i:changeIndex;
                  let i = index
                "
              >
                {{ feature | translate }}
              </li>
            </ul>
            <div *ngIf="plan.description.feature.length > 4">
              <a
                href="javascript:void(0)"
                class="text-primary"
                *ngIf="
                  (
                    plan.description.feature
                    | limitTo: planArrayLimit:i:changeIndex
                  ).length < 5
                "
                (click)="viewMore(i)"
                ><u> {{ "SUBSCRIPTION_INFO.VIEW_MORE" | translate }} </u></a
              >
              <a
                href="javascript:void(0)"
                class="text-primary"
                *ngIf="
                  (
                    plan.description.feature
                    | limitTo: planArrayLimit:i:changeIndex
                  ).length > 4
                "
                (click)="planArrayLimit = 4"
                ><u> {{ "SUBSCRIPTION_INFO.VIEW_LESS" | translate }} </u></a
              >
            </div>
            <span
              *ngIf="
                (plan.type | translate | lowercase).split(' ')[0] ==
                (userinfo.subscription_type | lowercase)
              "
              class="curent-plan-batch"
            >
              {{ "SUBSCRIPTION_INFO.CURRENT_PLAN" | translate }}
            </span>
            <button
              *ngIf="!userinfo.subscription_type"
              type="button"
              class="btn btn-theme"
              (click)="selectPlan(plan, i)"
            >
              {{ "SUBSCRIPTION_INFO.SUBSCRIBE" | translate }}
            </button>
            <button
              *ngIf="
                !(
                  (plan.type | translate | lowercase).split(' ')[0] ==
                  (userinfo.subscription_type | lowercase)
                ) && userinfo.subscription_type
              "
              type="button"
              class="btn btn-theme"
              (click)="selectPlan(plan, i)"
            >
              {{ "SUBSCRIPTION_INFO.CHANGE_PLAN" | translate }}
            </button>
          </div>
          <!-- <div class="plans-content">
            <p class="mb-0">{{ "SUBSCRIPTION_INFO.YEARLY" | translate }}</p>
            <i class="mdi mdi-calendar-month-outline"></i>
            <h1>$299</h1>
            <span class="text-secondary">
              {{ "SUBSCRIPTION_INFO.YEARLY_MESSAGE" | translate }}
            </span>
            <button
              type="button"
              class="btn btn-theme"
              (click)="toggleShow('2')"
            >
              {{ "SUBSCRIPTION_INFO.SUBSCRIBE" | translate }}
            </button>
          </div> -->
        </div>
      </div>
      <div class="row m-0" *ngIf="step_2 && planDetail">
        <div class="col-12">
          <div class="payment-form">
            <div class="side-bar">
              <div class="head">
                {{ "PAYMENT_INFO.PLAN_SUMMARY" | translate }}
              </div>
              <div class="side-bar-body">
                <div class="d-flex align-items-center">
                  <h4>
                    {{ planDetail?.type | translate | uppercase }}
                  </h4>
                  &nbsp;
                  <h4 class="mr-1">${{ planDetail?.price }}</h4>
                  <h6>{{ planDetail?.duration | translate }}</h6>
                </div>
                <div>
                  <ul>
                    <li
                      *ngFor="let feature of planDetail?.description?.feature"
                    >
                      <!-- <span class="icon-correct"></span> -->
                      {{ feature | translate }}
                    </li>
                  </ul>
                </div>
              </div>
              <div class="side-foot">
                <div class="d-flex align-items-center justify-content-between">
                  <p class="mb-0">{{ "PAYMENT_INFO.AMOUNT" | translate }}</p>
                  <h5>${{ planDetail.price }}</h5>
                </div>
                <div *ngIf="!isPromocode">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <p class="mb-0">
                      {{ "PAYMENT_INFO.APPLIED_COUPON" | translate }}
                    </p>
                    <h5>{{ model.promocode }}</h5>
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <p class="mb-0">
                      {{ "PAYMENT_INFO.DISCOUNT" | translate }}
                    </p>
                    <h5>-${{ discount | decimalNumber }}</h5>
                  </div>
                </div>
                <hr *ngIf="!isPromocode" />
                <div
                  *ngIf="!isPromocode"
                  class="d-flex align-items-center justify-content-between"
                >
                  <p class="mb-0">
                    {{ "PAYMENT_INFO.PAYABLE_AMOUNT" | translate }}
                  </p>
                  <h3 class="font-bold" *ngIf="plan == 1">
                    <span *ngIf="9.99 - discount !== 0">$</span>
                    <span>{{
                      9.99 - discount == 0 || discount >= 9.99
                        ? "Free"
                        : (9.99 - discount | decimalNumber)
                    }}</span>
                  </h3>
                  <h3 class="font-bold" *ngIf="plan == 2">
                    <span *ngIf="49.99 - discount !== 0">$</span>
                    <span>{{
                      49.99 - discount == 0 || discount >= 49.99
                        ? "Free"
                        : (49.99 - discount | decimalNumber)
                    }}</span>
                  </h3>
                  <h3 class="font-bold" *ngIf="plan == 3">
                    <span *ngIf="149.99 - discount !== 0">$</span>
                    <span>{{
                      149.99 - discount == 0 || discount >= 149.99
                        ? "Free"
                        : (149.99 - discount | decimalNumber)
                    }}</span>
                  </h3>
                  <h3 class="font-bold" *ngIf="plan == 4">
                    <span *ngIf="599.99 - discount !== 0">$</span>
                    <span>{{
                      599.99 - discount == 0 || discount >= 599.99
                        ? "Free"
                        : (599.99 - discount | decimalNumber)
                    }}</span>
                  </h3>
                </div>
              </div>
            </div>

            <form class="form-input" #subscriptionForm="ngForm">
              <div class="head">
                {{ "PAYMENT_INFO.PAYMENT_INFO" | translate }}
              </div>
              <div class="input-body row">
                <div
                  class="col-12 col-md-12 col-lg-12 col-xl-6 px-0 mb-4 position-relative"
                >
                  <div class="promo-input" *ngIf="!hide && showPromocode">
                    <input
                      type="text"
                      class="form-control"
                      name="promocode"
                      [(ngModel)]="model.promocode"
                      (keyup.enter)="applyPromoCode()"
                      #promocode="ngModel"
                      placeholder="Promocode"
                    />

                    <button
                      *ngIf="isPromocode"
                      type="button"
                      class="btn btn-theme"
                      (click)="applyPromoCode()"
                    >
                      <span class="spin icon-loader" *ngIf="isLoading"> </span>
                      {{ "PAYMENT_INFO.APPLY" | translate }}
                    </button>
                    <!-- <button
                      (click)="closePromoCode()"
                      *ngIf="!isPromocode"
                      type="button"
                      class="btn btn-danger"
                    >
                      Close
                    </button> -->
                  </div>
                  <div class="validation_div">
                    <p class="pl-3 mb-0" *ngIf="invalidCoupon">
                      {{ invalidCouponMessage }}
                    </p>
                  </div>
                  <p class="promo-code-text pl-3 mb-0" *ngIf="validCoupon">
                    {{ "PAYMENT_INFO.PROMOCODE_MESSAGE" | translate }}
                  </p>
                  <button
                    class="btn btn-theme ml-3 mt-1"
                    (click)="closePromoCode()"
                    *ngIf="!isPromocode"
                    type="button"
                  >
                    {{ "PAYMENT_INFO.CHANGE_PROMOCODE" | translate }}
                  </button>
                </div>
                <div class="form-group col-12 col-md-12 p-0">
                  <div class="form-group col-12 col-md-12 col-lg-12 col-xl-6">
                    <label>
                      {{ "PAYMENT_INFO.CARD_HOLDER_INFO" | translate }}</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      placeholder="{{
                        'PAYMENT_INFO.PAYMENT_HOLDER_NAME' | translate
                      }}"
                      name="card_holder_name"
                      [(ngModel)]="model.card_holder_name"
                      #card_holder_name="ngModel"
                      pattern="^[a-zA-Z ]*$"
                      required
                    />
                    <div
                      style="color: red"
                      class="validation_div ml-3"
                      *ngIf="
                        card_holder_name.errors &&
                        (card_holder_name.dirty || subscriptionForm.submitted)
                      "
                    >
                      <p class="mb-0" *ngIf="card_holder_name.errors.required">
                        {{ "PAYMENT_INFO.REQUIRED" | translate }}
                      </p>
                      <p
                        class="mb-0 red-text"
                        *ngIf="card_holder_name.errors.pattern"
                      >
                        {{ "PAYMENT_INFO.INVALID_NAME" | translate }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="form-group col-12 col-md-12 col-lg-12 col-xl-6">
                  <stripe-card
                    class="form-control"
                    #stripeCard
                    (catch)="onStripeError($event)"
                    [(invalid)]="invalidError"
                    (cardMounted)="(cardReady)"
                    (tokenChange)="setStripeToken($event)"
                    (sourceChange)="setStripeSource($event)"
                  ></stripe-card>
                </div>
                <div class="form-group col-12 col-md-12 pt-3">
                  <button
                    type="submit"
                    class="btn btn-theme"
                    (click)="getToken()"
                    [disabled]="btnDisable"
                  >
                    {{ "PAYMENT_INFO.PAYNOW" | translate }}
                  </button>
                </div>
              </div>

              <div
                class="side-foot info-foot d-flex align-items-center justify-content-between"
              >
                <a
                  href="javascript:void(0)"
                  class="btn btn-danger"
                  (click)="planShow(subscriptionForm)"
                >
                  {{ "PAYMENT_INFO.CHANGE_PLAN" | translate }}
                </a>
                <div>
                  <p class="mb-0">{{ "PAYMENT_INFO.NEED_HELP" | translate }}</p>
                  <a
                    href="javascript:void(0)"
                    class="orange-link"
                    target="_blank"
                    href="mailto:info@intelligens.com"
                    >
                    {{ "CONTACTUS.EMAIL_ID" | translate }}
                  </a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<app-footer></app-footer>
